import { render, staticRenderFns } from "./Pastures.vue?vue&type=template&id=b27b537e&scoped=true&"
import script from "./Pastures.vue?vue&type=script&lang=js&"
export * from "./Pastures.vue?vue&type=script&lang=js&"
import style0 from "./Pastures.vue?vue&type=style&index=0&id=b27b537e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27b537e",
  null
  
)

export default component.exports